import { useState } from 'react';
import Button from 'Components/Atoms/Button/Button';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function UnknownErrorMessage(props) {
    const { onClearConnection, onClose } = props;
    const [processing, setProcessing] = useState(false);

    const { t } = useTranslation('providers');

    const handleReject = async () => {
        setProcessing(true);
        await onClearConnection();
        onClose();
        setProcessing(false);
    };

    return (
        <div className="text-center">
            <div className="flex justify-center mb-6">
                <img src="/img/icon-error.svg" alt="" />
            </div>

            <h3 className="font-medium">{t('error-connecting')}</h3>
            <div className="text-gray-500">{t('error-connecting-description')}</div>

            <div className="mt-6">
                <Button variant="primary" isBusy={processing} onClick={handleReject}>
                    {t('accept')}
                </Button>
            </div>
        </div>
    );
}

UnknownErrorMessage.propTypes = {
    onClearConnection: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    description: PropTypes.string.isRequired,
};
